
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/coverage/testing",
      function () {
        return require("private-next-pages/docs/auth/coverage/testing.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/coverage/testing"])
      });
    }
  